<template>
  <div id="user" v-loading="loading">
    <nav-common></nav-common>
    <div class="user-content">
    <!-- <el-carousel class="slider-box" :autoplay="false" trigger="click" height="300px">
      <el-carousel-item>
        <schart :canvasId="chartPie.canvasId"
          :type="chartPie.type"
          :width="chartPie.width"
          :height="chartPie.height"
          :data="chartPie.data"
          :options="chartPie.options"
        ></schart>
      </el-carousel-item>
      <el-carousel-item>
        <schart :canvasId="volumesPie.canvasId"
          :type="volumesPie.type"
          :width="volumesPie.width"
          :height="volumesPie.height"
          :data="volumesPie.data"
          :options="volumesPie.options"
        ></schart>
      </el-carousel-item>
    </el-carousel> -->
      <el-tabs v-model="userControl">
        <el-tab-pane label="申请提现" name="withdra">
          <div class="withdra-box clearfix">
            <el-form class="fleft" ref="withdraform" :model="withdraform" label-width="100px">
              <div class="wallet">
                <p v-for="info of chartPie.data"><span v-text="info.name"></span><em v-text="info.value">100.00</em> 元</p>
              </div>
              <el-form-item label="提现金额">
                <el-input v-model="withdraform.money"></el-input>
              </el-form-item>
              <el-form-item label="到账银行卡">
                <el-select v-model="withdraform.bank_id" placeholder="请选择">
                  <el-option
                    v-for="(item,index) in card_list"
                    :key="item.id"
                    :label="item.bank_name + '(' + splitstr(item.bank_account) + ')'"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <div class="btn-box">
                <el-button @click="withdra" type="primary">确定申请</el-button>
              </div>
            </el-form>
            <div class="fleft withdra-list">
                <div class="withdra-list-title">提现申请列表</div>
                <el-table
                  :data="withdraList.data"
                  border
                  style="width: 800px">
                  <el-table-column
                    fixed
                    prop="created_at"
                    label="申请日期"
                    align="center"
                    width="170">
                  </el-table-column>
                  <el-table-column
                    prop="username"
                    label="姓名"
                    align="center"
                    width="70">
                  </el-table-column>
                  <el-table-column
                    prop="money"
                    label="提现金额"
                    align="center"
                    width="90">
                  </el-table-column>
                  <el-table-column
                    prop="bank_account"
                    label="到账银行卡"
                    align="center"
                    width="170">
                  </el-table-column>
                  <el-table-column
                    prop="bank_name"
                    label="所属银行"
                    align="center"
                    width="100">
                  </el-table-column>
                  <el-table-column
                    prop="status"
                    label="状态"
                    align="center"
                    width="80">
                  </el-table-column>
                  <el-table-column
                    fixed="right"
                    label="操作"
                    align="center"
                    width="110">
                    <template slot-scope="scope">
                      <el-button @click="cancelWithdra(scope.row.id)" type="text" size="small">取消申请</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <div class="btn-box">
                  <el-pagination
                  background
                  layout="prev, pager, next"
                  @current-change="getwithdraList"
                  :current-page="withdraList.current_page"
                  :total="withdraList.total">
                  </el-pagination>
                </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="实名认证" name="realName">
          <el-upload
            class="upload-demo"
            action="/"
            :before-upload="positiveUpload"
            :before-remove="handleRemove"
            :file-list="idcard.idCardPositive"
            list-type="picture">
            <el-button size="small" type="primary">点击上传身份证正面照片</el-button>
            <div slot="tip" class="el-upload__tip">请上传jpg/png格式的图片，注意不要超过500kb  <span v-show="idcard.idCardPositiveTips" style="color: red" v-text="idcard.status"></span></div>
          </el-upload>
          <el-upload
            class="upload-demo"
            action="/"
            :before-upload="backUpload"
            :before-remove="handleRemove"
            :file-list="idcard.idCardBack"
            list-type="picture">
            <el-button size="small" type="primary">点击上传身份证背面照片</el-button>
            <div slot="tip" class="el-upload__tip">请上传jpg/png格式的图片，注意不要超过500kb  <span v-show="idcard.idCardBackTips" style="color: red"  v-text="idcard.status"></span></div>
          </el-upload>
        </el-tab-pane>
        <el-tab-pane label="银行卡列表" name="banks">
          <ul class="bank-list">
            <li v-for="(card,index) of card_list">
              <div class="title">
                <div class="user-name">姓名：<span v-text="card.username"></span></div>
                <div class="bank-name">所属银行：<span v-text="card.bank_name"></span></div>
              </div>
              <div class="content">
                <p>银行卡号码：<span v-text="card.bank_account"></span></p>
                <p>开户支行：<span v-text="card.bank_branch"></span></p>
                <p>添加时间：<span v-text="card.created_at"></span></p>
                <router-link tag="button" class="edit" :to="{ path: 'Editbank', query: { cardinfo: card_list[index]}}">改</router-link>
                <el-button type="default" class="edit delete" @click="deletebanks(card.id)">删</el-button>
                <!-- <el-button type="default" class="edit" @click="editbanks(index)">改</el-button> -->
              </div>
              <div class="bottom">
                <div class="status" v-text="card.status"></div>
                <div class="reason" v-text="card.status_reason"></div>
              </div>
            </li>
          </ul>
          <div class="btn-box">
            <el-button type="primary" @click="toUrl('/Addbank')">添加银行卡</el-button>
          </div>
        </el-tab-pane>
        <el-tab-pane label="重置密码" name="resetpassword">
          <el-form ref="passwordform" :model="passwordform" label-width="100px">
            <el-form-item label="旧密码">
              <el-input v-model="passwordform.old_password"></el-input>
            </el-form-item>
            <el-form-item label="新密码">
              <el-input type="password" v-model="passwordform.new_password"></el-input>
            </el-form-item>
            <el-form-item label="确认密码">
              <el-input type="password" v-model="passwordform.confirm_password"></el-input>
            </el-form-item>
          </el-form>
          <div class="btn-box">
            <el-button @click="resetpassword" type="primary">确定修改</el-button>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Schart from 'vue-schart';
import NavCommon from '@/components/navtop/navcommon'

export default {
  name: 'User',
  data () {
    return {
      loading: false,
      chartPie: {
        canvasId: 'pieCanvas',
        type: 'pie',
        width: 600,
        height: 300,
        data: [
          {name: '总收益', value: 0},
          {name: '已提现', value: 0},
          {name: '处理中', value: 0},
          {name: '余额', value: 0},
        ],
        options: {
          title: '收入详情'
        }
      },
      volumesPie: {
        canvasId: 'volumesCanvas',
        type: 'pie',
        width: 600,
        height: 300,
        data: [
          {name: '办卡', value: 0},
          {name: '贷款', value: 0}
        ],
        options: {
          title: '成交量'
        }
      },
      userControl: 'withdra',
      idcard: {
        idCardPositive: [],
        idCardPositiveTips: false,
        idCardBack: [],
        idCardBackTips: false,
        status: ''
      },
      card_list: [],
      withdraList: {},
      passwordform: {
        old_password: '',
        new_password: '',
        confirm_password: ''
      },
      withdraform: {
        bank_id: '',
        money: ''
      }
    }
  },
  created() {
    this.getInfo();
    this.getIdCard();
    this.getbanks();
    this.getwithdraList();
    this.getvolumes();
  },
  methods: {
    getInfo() {
  		var _this = this;
  		this.$http({
  			method: 'get',
  			url: _this.$api + '/service/agent/user/info',
  		}).then(function(res){
  			if(res.data.code == 200) {
            let data = res.data.data;
            _this.chartPie.data = [
                {name: '历史总收益：', value: parseFloat(data.withdrawals_money) + parseFloat(data.dealing_money) + parseFloat(data.remain_money)},
                {name: '已提现金额：', value: parseFloat(data.withdrawals_money)},
                {name: '处理中金额：', value: parseFloat(data.dealing_money)},
                {name: '可提现金额：', value: parseFloat(data.remain_money)}
            ]
  			} else {

  			}
  		})
    },
    getvolumes() {
      let _this = this;
      _this.$http({
        method: 'get',
        url: _this.$api + '/service/agent/visual/volumes'
      }).then((res) => {
        if(res.data.code == 200) {
          let data = res.data.data;
          _this.volumesPie.data = [
            {name: '办卡', value: data.card_count},
            {name: '贷款', value: data.loan_count}
          ]
        }
      });
    },
    handleRemove(file, fileList) {
      this.$message.error('不支持删除操作，点击按钮可重新上传照片');
      return false;
    },
    handlePreview(file) {
      console.log(file);
    },
    positiveUpload(file) {
      var _this = this;
   		var formData = new FormData();
       formData.append('file',file);
      _this.$http({
        method: 'post',
        url: _this.$api + '/service/agent/user/submit_id_card',
        data: formData
      }).then((res) => {
        if(res.data.code == 200) {
          this.$message.success('上传成功，请等待后台审核');
          _this.getIdCard();
        }
      })
    },
    backUpload(file) {
      var _this = this;
   		var formData = new FormData();
       formData.append('file_two',file);
      _this.$http({
        method: 'post',
        url: _this.$api + '/service/agent/user/submit_id_card',
        data: formData
      }).then((res) => {
        if(res.data.code == 200) {
          this.$message.success('上传成功，请等待后台审核');
          _this.getIdCard();
        }
      })
    },
    getIdCard() {
      var _this = this;
      _this.$http({
        method: 'get',
        url: _this.$api + '/service/agent/user/get_id_card'
      }).then((res) => {
        _this.idcard.idCardPositive = [{
          name: 'positive.jpeg',
          url: res.data.data.positive
        }];
        _this.idcard.idCardBack = [{
          name: 'back.jpeg',
          url: res.data.data.back
        }];
      });
    },
    getbanks() {
  		var _this = this;
  		this.$http({
  			method: 'get',
  			url: _this.$api + '/service/agent/user/card_list',
  		}).then(function(res){
  			_this.card_list = res.data.data;
  			_this.card_list.forEach((e) => {
  				if(e.status == 0) {
  					e.status = '审核中';
	  			} else if(e.status == 1) {
	  				e.status = '审核通过';
	  			} else if(e.status == 2) {
	  				e.status = '审核失败';
	  			}
  			})
  		})
  	},
    editbanks(index) {
      this.$router.push({ path: 'Editbank', query: { cardinfo: this.card_list[index] }})
  	},
  	deletebanks(id) {
      this.$alert('是否确认删除？', '提示', {
          confirmButtonText: '确定',
          callback: action => {
            var params = new URLSearchParams();
            params.append('id',id);
            this.$http({
              method: 'post',
              url: _this.$api + '/service/agent/user/delete_card',
              data: params
            }).then((res) => {
              this.loading = false;
              this.$message.success('删除成功');
            });
          }
      });
    },
    toUrl(url) {
      this.$router.push(url);
    },
    getwithdraList(page) {
      var _this = this;
      _this.$http({
        method: 'get',
        url: _this.$api + '/service/agent/user/withdrawals_list?page=' + page
      }).then((res) => {
        _this.withdraList = res.data.data;
        _this.withdraList.data.forEach((item) => {
          item.status = _this.status(item.status);
        });
      })
    },
    cancelWithdra(id) {
      var _this = this;
      this.$alert('确认取消吗？', '提示', {
          confirmButtonText: '确定',
          callback: action => {
            var params = new URLSearchParams();
            params.append('id',id);
            this.$http({
              method: 'post',
              url: _this.$api + '/service/agent/user/cancel_withdrawals',
              data: params
            }).then(function(res){
              if(res.data.code == 200) {
                _this.getwithdraList();
                _this.$message.success(res.data.data);
              } else {
                _this.$message.error(res.data.data);
              }
            })
          }
      });
    },
    withdra() {
      var _this = this;
      _this.loading = true;
      var params = new URLSearchParams();
      params.append('bank_id',_this.withdraform.bank_id);
      params.append('money',_this.withdraform.money);
      _this.$http({
        method: 'post',
        url: _this.$api + '/service/agent/user/set_withdrawals',
        data: params
      }).then((res) => {
        _this.loading = false;
        if(res.data.code == 200) {
          _this.$message.success(res.data.data);
        } else {
          _this.$message.error(res.data.data);
        }
      })
    },
    resetpassword() {
      var _this = this;
      _this.loading = true;
      var params = new URLSearchParams();
      var passwordform = _this.passwordform;
      params.append('old_password',passwordform.old_password);
      params.append('new_password',passwordform.new_password);
      params.append('confirm_password',passwordform.confirm_password);
      _this.$http({
        method: 'post',
        url: _this.$api + '/service/agent/password',
        data: params
      }).then((res) => {
        _this.loading = false;
        if(res.data.code == 200) {
          _this.$message.success('密码修改成功');
        } else {
          _this.$message.error(res.data.data);
        }
      })
    },
    status(num) {
  		var str = '';
  		if(num == 0) {
  			str = '申请中';
  		} else if(num == 1) {
  			str = '已打款';
  		} else {
  			str = '已取消';
  		}
  		return str;
    },
    splitstr(str) {
      return str.substr(-4);
    }
  },
  components: {
    Schart,
    NavCommon
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus" rel="stylesheet/stylus">
  #user
    .user-content
      position relative
      margin 20px
      padding 60px 40px 20px 40px
      background #f8f8f8
      box-shadow 3px 3px 3px #f5f5f5 inset
      .withdra-box
        width 100%
      .el-form
        width 350px
        margin-right 30px
        label
          text-align left
        .wallet
          background #fff
          margin 40px auto 20px auto
          padding 10px 20px
          p
            margin 10px 0
          em
            color red
      .withdra-list
        .withdra-list-title
          width 100%
          height 40px
          line-height 40px
          text-align center
      #pane-realName
        width 50%
      #pane-resetpassword
        width 50%
    .slider-box
      margin-bottom: 20px
      .el-carousel__item
        width: 600px
        left: 50%
        margin-left: -300px
    .upload-demo
      margin-bottom: 15px
    .btn-box
      width 50%
      margin: 15px 0
      text-align: center
    .bank-list
      li
        position: relative
        width: 50%
        margin: 10px 0
        .title
          display: flex
          height: 40px
          line-height: 40px
          background: #123e96
          padding: 0 15px
          fong-size: 14px
          color: #fff
          border-top-left-radius: 10px
          border-top-right-radius: 10px
          .user-name
            flex: 1
          .bank-name
            flex: 1
            text-align: right
        .content
          position: relative
          background: #ffffff
          font-size: 14px
          padding: 10px
          p
            margin: 10px auto
          .edit
            position: absolute
            width: 30px
            height: 30px
            border-radius: 50%
            line-height: 30px
            padding: 0
            top: 30%
            right: 20px
            margin-top: -15px
          .delete
            top: 70%
        .bottom
            display: flex
            heihgt: 40px
            line-height: 40px
            background: #f56c6c
            color: #ffffff
            padding: 0 15px
            .status
              flex: 1
            .reason
              flex: 1
              text-align: right
</style>
<style>
  .el-table .warning-row {
    background: oldlace;
  }

  .el-table .success-row {
    background: #f0f9eb;
  }
  .el-form-item__label {
    text-align: left;
  }
  .el-tabs__header {
    margin-bottom: 30px
  }
</style>



// WEBPACK FOOTER //
// src/components/user/user.vue